import {
  GETREFUNDDETAILSADMIN_SUCCESS,
  GETREFUNDDETAILSADMIN_FAILED,
  RESET_GETREFUNDDETAILSADMIN,
  LOADING_GETREFUNDDETAILSADMIN,
  NETWORK_ERROR_GETREFUNDDETAILSADMIN,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETREFUNDDETAILSADMIN:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETREFUNDDETAILSADMIN_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETREFUNDDETAILSADMIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETREFUNDDETAILSADMIN:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETREFUNDDETAILSADMIN:
      return (state = initialState);
    default:
      return state;
  }
};
